import { Link } from '@tiendanube/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { useProductsList } from 'domains/Catalog/Products/pages/hooks';
import { useBulkActions } from '../../../BulkActionsProvider';

export function SelectAllElement() {
  const t = useTranslationCatalog();

  const { productsCount, productsIds } = useProductsList();
  const { selectAll, setSelectAll, setSelectedRowsId } = useBulkActions();

  const textSelectAllElement = !selectAll
    ? t(`products.bulkActions.selectAll`, { count: productsCount })
    : t(`products.bulkActions.deselectAll`, { count: productsCount });

  const handleOnSelectAll = (value: boolean) => {
    if (value) setSelectedRowsId(productsIds);
    else setSelectedRowsId([]);
    setSelectAll(value);
  };

  return (
    <Link
      appearance="primary"
      size="small"
      onClick={() => handleOnSelectAll(!selectAll)}
    >
      {textSelectAllElement}
    </Link>
  );
}
